// Incoming call ringtone (Web Audio dual-tone) + vibration loop
import { Capacitor } from "@capacitor/core";

let ctx = null;
let ringInterval = null;
let vibeInterval = null;

const ringBurst = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const now = ctx.currentTime;
    // Classic phone ring: two dual-tone bursts (440+480 Hz)
    [0, 0.6].forEach((offset) => {
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0.0001, now + offset);
      gain.gain.linearRampToValueAtTime(0.3, now + offset + 0.03);
      gain.gain.setValueAtTime(0.3, now + offset + 0.35);
      gain.gain.linearRampToValueAtTime(0.0001, now + offset + 0.42);
      gain.connect(ctx.destination);
      [440, 480].forEach((f) => {
        const osc = ctx.createOscillator();
        osc.type = "sine";
        osc.frequency.value = f;
        osc.connect(gain);
        osc.start(now + offset);
        osc.stop(now + offset + 0.45);
      });
    });
  } catch {}
};

const vibrateOnce = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      const { Haptics } = await import("@capacitor/haptics");
      await Haptics.vibrate({ duration: 600 });
    } else if ("vibrate" in navigator) {
      navigator.vibrate([400, 200, 400]);
    }
  } catch {}
};

export const startRingtone = () => {
  if (ringInterval) return;
  ringBurst();
  vibrateOnce();
  ringInterval = setInterval(ringBurst, 2500);
  vibeInterval = setInterval(vibrateOnce, 2500);
};

export const stopRingtone = () => {
  clearInterval(ringInterval);
  clearInterval(vibeInterval);
  ringInterval = null;
  vibeInterval = null;
  try { if ("vibrate" in navigator) navigator.vibrate(0); } catch {}
};
